export function requiredText(data: FormData, name: string): string {
  const value = data.get(name);
  return typeof value === 'string' ? value.trim() : '';
}

export function formText(data: FormData, name: string): string {
  const value = data.get(name);
  return typeof value === 'string' ? value : '';
}

export function integerValue(data: FormData, name: string): number {
  return Number.parseInt(requiredText(data, name), 10);
}
